import { render } from "./ResidenceDetails.vue?vue&type=template&id=f82dbbee"
import script from "./ResidenceDetails.vue?vue&type=script&lang=js"
export * from "./ResidenceDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__